import React from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';


function ModalSearchPorfolio( {handleOpen, isOpen, setSearch, search, doSearch}) {

    const doSearchButton = () => {
        doSearch(search)
        handleOpen(false)
    }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  <i className="tf-icons bx bx-filter" /> Buscar </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Nombre</FormLabel>
                                <Input size="md" placeholder="Nombre Comercial"
                                    value={search.instrumento}
                                    onChange={(e)=> setSearch({...search, name: e.target.value}) }
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info mb-2 d-grid w-100" onClick={doSearchButton}>Buscar</button>            
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalSearchPorfolio;